const disableBodyScrolling = () => {
  const bodyStyle = document?.body?.style;
  if (bodyStyle && window) {
    const nextScrollPosition =
      bodyStyle.position === 'fixed' ? document.body.dataset.yScrollPositionBeforeDisable : window.scrollY;
    document.body.dataset.yScrollPositionBeforeDisable = `${nextScrollPosition}`;
    bodyStyle.top = `-${nextScrollPosition}px`;
    bodyStyle.overflowY = 'scroll';
    bodyStyle.position = 'fixed';
    bodyStyle.width = '100%';
  }
};

const enableBodyScrolling = () => {
  const bodyStyle = document?.body?.style;
  if (bodyStyle && window) {
    const stylePropertiesToRemove = ['overflow-y', 'position', 'top', 'width'];
    stylePropertiesToRemove.forEach((propName) => bodyStyle.removeProperty(propName));
    if (document.body.dataset.yScrollPositionBeforeDisable) {
      const prevScrollYPosition = parseInt(document.body.dataset.yScrollPositionBeforeDisable, 10);
      window.scrollTo(0, prevScrollYPosition);
    }
  }
};

export const disableScrolling = (shouldBeDisabled: boolean): void => {
  if (shouldBeDisabled) {
    disableBodyScrolling();
  } else {
    enableBodyScrolling();
  }
};
